import { render, staticRenderFns } from "./SubstanceManagementModule.vue?vue&type=template&id=bde7f6ea&scoped=true"
import script from "./SubstanceManagementModule.vue?vue&type=script&lang=js"
export * from "./SubstanceManagementModule.vue?vue&type=script&lang=js"
import style0 from "./SubstanceManagementModule.vue?vue&type=style&index=0&id=bde7f6ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde7f6ea",
  null
  
)

export default component.exports